import logo from "../img/cover.png";
import heart from "../img/heart.svg";
import cart from "../img/cart.svg";
import user from "../img/user.svg";
import {Link} from "react-router-dom";

export default function Navbar({isUser}) {
  return (
    <nav className="navbar">
        <img src = {logo} alt = "logo" className="nav-logo"/>

        <div className="links">
            <Link to = "/">Home</Link>
            <Link to = {isUser ? "/shop" : "/login"}>Shop</Link>
            <Link to = {isUser ? "/account" : "/login"}>Account</Link>
        </div>

        <div className="link-icons">
            <Link to = {isUser ? "/account" : "/login"}><img src = {user}/></Link>
            <Link to = {isUser ? "/cart" : "/login"}><img src = {cart}/></Link>
            <Link to = {isUser ? "/wishlist" : "/login"}><img src = {heart}/></Link>
        </div>
    </nav>
  )
}
